'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */


function connect(mapStylesToProps) {
  return function (Comp) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
      _inherits(EnhancedComponent, _Component);

      function EnhancedComponent() {
        _classCallCheck(this, EnhancedComponent);

        return _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).apply(this, arguments));
      }

      _createClass(EnhancedComponent, [{
        key: 'render',

        // reuse the initial displayName name
        value: function render() {
          var _context = this.context,
              renderer = _context.renderer,
              theme = _context.theme;

          // invoke the component name for better CSS debugging

          if (process.env.NODE_ENV !== 'production') {
            this.context.renderer._selectorPrefix = Comp.displayName || Comp.name || 'ConnectedFelaComponent';
          }

          // invoke props and renderer to render all styles
          var styles = mapStylesToProps(_extends({}, this.props, {
            theme: theme || {}
          }))(renderer);

          // remove the component name after rendering
          if (process.env.NODE_ENV !== 'production') {
            this.context.renderer._selectorPrefix = undefined;
          }

          return _react2.default.createElement(Comp, _extends({}, this.props, { styles: styles }));
        }
      }]);

      return EnhancedComponent;
    }(_react.Component), _class.displayName = Comp.displayName || Comp.name || 'ConnectedFelaComponent', _class.contextTypes = _extends({}, Comp.contextTypes, {
      renderer: _react.PropTypes.object,
      theme: _react.PropTypes.object
    }), _temp;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/bindings/react/connect.js
// module id = 403
// module chunks = 0